module.exports = __webpack_public_path__ + "img/es.54c568f0.png";